import { FormInstance, Rule } from "antd/lib/form"
import i18n from "i18next"
import { isNotSet, isNumeric, isUniqueInReduxAndForm } from "Shared/utils/helpers"

const ExpenseAccountRules = (formInstance: FormInstance, isEdit: boolean): { [key: string]: Rule[] } => ({
    accountCode: [
        {
            validator: (_rule: any, value: string) => {
                if (!value) {
                    return Promise.reject(i18n.t("validation:required"))
                }

                if (!isUniqueInReduxAndForm("expenseAccounts", "accountCode", formInstance, value, isEdit)) {
                    return Promise.reject(i18n.t("validation:unique", { value: i18n.t("validation:account_code") }))
                }

                return Promise.resolve()
            },
        },
    ],
    accountName: [
        {
            validator: (_rule: any, value: string) => {
                if (isNotSet(value)) {
                    return Promise.reject(i18n.t("validation:required"))
                }

                if (!isUniqueInReduxAndForm("expenseAccounts", "accountName", formInstance, value, isEdit)) {
                    return Promise.reject(i18n.t("validation:unique", { value: i18n.t("validation:account_name") }))
                }

                return Promise.resolve()
            },
        },
    ],
})

export default ExpenseAccountRules
